module.exports = __webpack_public_path__ + "img/three-col-grid-icon.7e2eac18.svg";